export interface Video {
  id: string;
  title: string;
  thumbnail: string;
  category: string;
  duration: string;
  views: string;
  rating: number;
  description: string;
  tags: string[];
  releaseDate: string;
  director: string;
  actors: string[];
  updateInfo: string;
  isHot: boolean;
  isNew: boolean;
  quality: string;
  episodes: string;
}

export interface VideoCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const videoCategories: VideoCategory[] = [
  { slug: 'hot', name: '热门推荐', icon: 'ri-fire-line', description: '全网最热视频，实时更新热门排行榜' },
  { slug: 'drama', name: '电视剧', icon: 'ri-tv-line', description: '国产、韩剧、美剧、日剧海量电视剧合集' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line', description: '院线大片、经典电影高清在线观看' },
  { slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门综艺节目最新期高清在线' },
  { slug: 'anime', name: '动漫', icon: 'ri-ghost-line', description: '国漫日漫美漫海量动画作品合集' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', description: '精选高品质纪录片，探索世界奥秘' },
  { slug: 'short', name: '短剧', icon: 'ri-smartphone-line', description: '精品短剧爽剧，一集上头停不下来' },
  { slug: 'creative', name: '创意视频', icon: 'ri-lightbulb-flash-line', description: '创意短视频、原创内容，精彩纷呈' },
];

export const videos: Video[] = [
  {
    id: 'v001',
    title: '苍穹之下：末日重生',
    thumbnail: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20sci%20fi%20drama%20scene%20with%20survivors%20in%20ruined%20city%2C%20cinematic%20lighting%2C%20dramatic%20sky%20with%20orange%20and%20gray%20tones%2C%20high%20contrast%2C%20movie%20poster%20style%2C%20epic%20atmosphere&width=640&height=360&seq=video-thumb-001&orientation=landscape',
    category: 'drama',
    duration: '45分钟',
    views: '1287万',
    rating: 9.2,
    description: '一场突如其来的灾难摧毁了人类文明，幸存者们在这片破碎的世界中艰难求生。当他们发现一个可能改变人类命运的秘密时，一切才刚刚开始...',
    tags: ['科幻', '末日', '悬疑', '国产剧'],
    releaseDate: '2026-07-15',
    director: '林海峰',
    actors: ['张译', '刘浩存', '王景春', '周也'],
    updateInfo: '更新至第36集',
    isHot: true,
    isNew: false,
    quality: '4K',
    episodes: '全40集',
  },
  {
    id: 'v002',
    title: '繁华似锦',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20with%20elegant%20traditional%20costumes%2C%20beautiful%20garden%20setting%20with%20cherry%20blossoms%2C%20warm%20golden%20lighting%2C%20romantic%20atmosphere%2C%20film%20poster%20style&width=640&height=360&seq=video-thumb-002&orientation=landscape',
    category: 'drama',
    duration: '42分钟',
    views: '965万',
    rating: 8.9,
    description: '讲述了民国时期一位才女在动荡年代中的成长故事，她用自己的智慧和勇气在繁华都市中闯出一片天地。',
    tags: ['民国', '爱情', '励志', '国产剧'],
    releaseDate: '2026-06-20',
    director: '陈思明',
    actors: ['赵丽颖', '王一博', '陈晓', '李沁'],
    updateInfo: '更新至第28集',
    isHot: true,
    isNew: false,
    quality: '4K',
    episodes: '全36集',
  },
  {
    id: 'v003',
    title: '星际迷航：新纪元',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20exploration%20movie%20scene%20with%20spaceship%20and%20distant%20galaxies%2C%20deep%20space%20background%20with%20nebula%20colors%2C%20cinematic%20sci%20fi%20style%2C%20epic%20adventure&width=640&height=360&seq=video-thumb-003&orientation=landscape',
    category: 'movie',
    duration: '128分钟',
    views: '2356万',
    rating: 9.5,
    description: '人类文明的最后希望寄托在一艘星际飞船上，勇敢的探险队将穿越未知宇宙寻找新家园。一场跨越时空的宏大冒险。',
    tags: ['科幻', '冒险', '好莱坞', '大片'],
    releaseDate: '2026-07-01',
    director: '詹姆斯·卡梅隆',
    actors: ['汤姆·克鲁斯', '艾玛·斯通', '摩根·弗里曼'],
    updateInfo: '已完结',
    isHot: true,
    isNew: true,
    quality: '蓝光',
    episodes: '',
  },
  {
    id: 'v004',
    title: '笑傲江湖之东方不败',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20film%20scene%20with%20warriors%20in%20flowing%20robes%20on%20mountaintop%2C%20misty%20atmosphere%2C%20dramatic%20composition%2C%20classic%20wuxia%20style%2C%20golden%20sunset%20lighting&width=640&height=360&seq=video-thumb-004&orientation=landscape',
    category: 'movie',
    duration: '135分钟',
    views: '1890万',
    rating: 9.1,
    description: '经典武侠小说改编，东方不败重出江湖，一场震撼人心的江湖恩怨即将展开。',
    tags: ['武侠', '动作', '经典', '华语'],
    releaseDate: '2026-05-18',
    director: '徐克',
    actors: ['李连杰', '林青霞', '甄子丹', '关之琳'],
    updateInfo: '已完结',
    isHot: false,
    isNew: false,
    quality: '4K修复',
    episodes: '',
  },
  {
    id: 'v005',
    title: '欢乐制造机 第九季',
    thumbnail: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20stage%20with%20energetic%20performers%2C%20cheerful%20atmosphere%2C%20studio%20lighting%2C%20entertainment%20show%20style%2C%20fun%20and%20vibrant&width=640&height=360&seq=video-thumb-005&orientation=landscape',
    category: 'variety',
    duration: '90分钟',
    views: '3521万',
    rating: 9.0,
    description: '国内最火爆的搞笑综艺节目回归！全新嘉宾阵容，更多爆笑挑战，让你笑到停不下来！',
    tags: ['搞笑', '综艺', '真人秀', '热门'],
    releaseDate: '2026-07-10',
    director: '',
    actors: ['何炅', '沈腾', '贾玲', '杨迪', '关晓彤'],
    updateInfo: '每周五更新',
    isHot: true,
    isNew: false,
    quality: '1080P',
    episodes: '第9季连载中',
  },
  {
    id: 'v006',
    title: '江湖风云录',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20Chinese%20martial%20arts%20fantasy%20scene%20with%20floating%20mountains%20and%20waterfalls%2C%20vibrant%20colors%2C%20dynamic%20composition%2C%20epic%20adventure%2C%20donghua%20style&width=640&height=360&seq=video-thumb-006&orientation=landscape',
    category: 'anime',
    duration: '24分钟',
    views: '876万',
    rating: 9.3,
    description: '少年林逸偶然获得神秘武功秘籍，从此踏上了一条充满挑战与奇遇的江湖之路。国漫巅峰之作！',
    tags: ['国漫', '武侠', '热血', '奇幻'],
    releaseDate: '2026-06-05',
    director: '',
    actors: [],
    updateInfo: '更新至第52集',
    isHot: true,
    isNew: false,
    quality: '4K',
    episodes: '连载中',
  },
  {
    id: 'v007',
    title: '地球脉动：深海秘境',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20exotic%20marine%20life%2C%20crystal%20clear%20blue%20water%2C%20natural%20light%20rays%2C%20BBC%20nature%20documentary%20style&width=640&height=360&seq=video-thumb-007&orientation=landscape',
    category: 'documentary',
    duration: '58分钟',
    views: '654万',
    rating: 9.7,
    description: '跟随顶尖水下摄影团队潜入深海世界，揭开海洋最深处不为人知的秘密与壮丽景观。',
    tags: ['自然', '海洋', 'BBC级别', '高清'],
    releaseDate: '2026-04-22',
    director: '',
    actors: [],
    updateInfo: '全6集已完结',
    isHot: false,
    isNew: true,
    quality: '4K HDR',
    episodes: '全6集',
  },
  {
    id: 'v008',
    title: '逆袭人生：从外卖小哥到CEO',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20urban%20Chinese%20drama%20scene%20with%20young%20man%20in%20business%20suit%20looking%20at%20city%20skyline%2C%20inspirational%20atmosphere%2C%20warm%20evening%20light%2C%20motivational%20story%20style&width=640&height=360&seq=video-thumb-008&orientation=landscape',
    category: 'short',
    duration: '3分钟',
    views: '5230万',
    rating: 9.4,
    description: '一个普通外卖小哥凭借坚韧不拔的意志和商业头脑，一步步逆袭成为科技公司CEO的励志短剧。',
    tags: ['励志', '短剧', '爽剧', '逆袭'],
    releaseDate: '2026-07-20',
    director: '',
    actors: ['彭昱畅', '谭松韵'],
    updateInfo: '更新至第88集',
    isHot: true,
    isNew: true,
    quality: '1080P',
    episodes: '全100集',
  },
  {
    id: 'v009',
    title: '创意工坊：生活中的黑科技',
    thumbnail: 'https://readdy.ai/api/search-image?query=Creative%20workshop%20with%20various%20DIY%20gadgets%20and%20tools%2C%20bright%20modern%20studio%20setting%2C%20innovative%20atmosphere%2C%20maker%20culture%20style%2C%20clean%20and%20organized&width=640&height=360&seq=video-thumb-009&orientation=landscape',
    category: 'creative',
    duration: '8分钟',
    views: '432万',
    rating: 8.8,
    description: '每期带你发现一个令人惊叹的生活黑科技，用创意改变生活。从实用工具到趣味发明，应有尽有！',
    tags: ['创意', '科技', '生活', 'DIY'],
    releaseDate: '2026-07-08',
    director: '',
    actors: [],
    updateInfo: '每周三更新',
    isHot: false,
    isNew: true,
    quality: '1080P',
    episodes: '连载中',
  },
  {
    id: 'v010',
    title: '暗夜追踪',
    thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20scene%20with%20detective%20in%20rainy%20city%20street%20at%20night%2C%20neon%20lights%20reflection%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20suspenseful&width=640&height=360&seq=video-thumb-010&orientation=landscape',
    category: 'drama',
    duration: '50分钟',
    views: '765万',
    rating: 8.7,
    description: '一位退休刑警被迫重返岗位，追查一桩尘封二十年的悬案。真相远比想象中更加复杂。',
    tags: ['悬疑', '刑侦', '犯罪', '国产剧'],
    releaseDate: '2026-06-30',
    director: '王伟',
    actors: ['段奕宏', '秦昊', '谭卓', '张颂文'],
    updateInfo: '更新至第18集',
    isHot: false,
    isNew: false,
    quality: '4K',
    episodes: '全24集',
  },
  {
    id: 'v011',
    title: '极限挑战：荒野求生',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20survival%20variety%20show%20scene%20in%20dense%20forest%2C%20adventurers%20building%20shelter%2C%20dramatic%20natural%20lighting%2C%20exciting%20wilderness%20atmosphere&width=640&height=360&seq=video-thumb-011&orientation=landscape',
    category: 'variety',
    duration: '75分钟',
    views: '2100万',
    rating: 8.6,
    description: '明星嘉宾被投放到原始荒野，在极限环境中挑战生存技能，真实记录他们的求生之旅。',
    tags: ['户外', '冒险', '真人秀', '热门'],
    releaseDate: '2026-07-05',
    director: '',
    actors: ['黄渤', '张艺兴', '杨紫', '王俊凯'],
    updateInfo: '每周六更新',
    isHot: false,
    isNew: false,
    quality: '1080P',
    episodes: '连载中',
  },
  {
    id: 'v012',
    title: '千年狐妖',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20scene%20with%20beautiful%20fox%20spirit%20in%20ancient%20Chinese%20setting%2C%20mystical%20atmosphere%20with%20cherry%20blossoms%2C%20ethereal%20lighting%2C%20romantic%20donghua%20style&width=640&height=360&seq=video-thumb-012&orientation=landscape',
    category: 'anime',
    duration: '22分钟',
    views: '1543万',
    rating: 9.6,
    description: '修炼千年的狐妖少女来到现代都市，一段跨越千年的爱情故事在繁华都市中展开。',
    tags: ['国漫', '奇幻', '爱情', '古风'],
    releaseDate: '2026-07-12',
    director: '',
    actors: [],
    updateInfo: '更新至第24集',
    isHot: true,
    isNew: true,
    quality: '4K',
    episodes: '连载中',
  },
];

export const heroBanners = [
  {
    id: 'b001',
    videoId: 'v003',
    title: '星际迷航：新纪元',
    subtitle: '2026年最受期待科幻巨制 · 全球同步首映',
    bgImage: 'https://readdy.ai/api/search-image?query=Epic%20sci%20fi%20space%20adventure%20scene%20with%20gigantic%20spaceship%20approaching%20a%20distant%20colorful%20planet%2C%20stars%20and%20nebula%20in%20background%2C%20cinematic%20movie%20poster%20quality%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20tones%2C%20abstract%20cosmic%20style&width=1600&height=700&seq=hero-banner-001&orientation=landscape',
  },
  {
    id: 'b002',
    videoId: 'v001',
    title: '苍穹之下：末日重生',
    subtitle: '国产科幻巨制 · 口碑爆棚热播中',
    bgImage: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20cityscape%20with%20golden%20sunset%20breaking%20through%20dark%20clouds%2C%20ruins%20with%20hope%2C%20cinematic%20atmosphere%2C%20warm%20dramatic%20tones%2C%20abstract%20painterly%20style&width=1600&height=700&seq=hero-banner-002&orientation=landscape',
  },
  {
    id: 'b003',
    videoId: 'v008',
    title: '逆袭人生',
    subtitle: '现象级短剧 · 5亿播放量神话',
    bgImage: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunrise%20with%20warm%20golden%20light%2C%20inspirational%20atmosphere%2C%20abstract%20geometric%20style%20with%20soft%20gradients%2C%20motivational%20and%20uplifting&width=1600&height=700&seq=hero-banner-003&orientation=landscape',
  },
];